/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CreateContactRequestContactFromJSON, CreateContactRequestContactToJSON } from './CreateContactRequestContact';
export function CreateContactRequestFromJSON(json) {
    return CreateContactRequestFromJSONTyped(json, false);
}
export function CreateContactRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        contact: !exists(json, 'contact') ? undefined : CreateContactRequestContactFromJSON(json['contact'])
    };
}
export function CreateContactRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        contact: CreateContactRequestContactToJSON(value.contact)
    };
}
